<template>
    <div class="compBox">
        <div class="isSHow" >
            <div class="tabels">
                <div class="compBox" style="margin-top: 0;">
                    <div class="table" v-loading="loading">
                        <div class="selectBox">
                            <!-- <el-select size="small" style="width: 100px;margin-right: 5px;" v-model="value11"
                                placeholder="请选择">
                                <el-option v-for="item in options11" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select size="small" style="width: 100px;margin-right: 5px;" v-model="value111"
                                placeholder="请选择">
                                <el-option v-for="item in options111" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                            <!-- <el-select size="small" style="width: 250px;margin-right: 5px;" v-model="value22"
                                placeholder="请选择">
                                <el-option v-for="item in options22" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                        </div>
                        <div style="height: 31px;">
                            <div class="pl20 dir-td f14 fw600">
                                招生方向：{{ name }}({{ code }})
                            </div>
                        </div>
                        <div style="height: 36px;">
                            <table class="my-table head" style="top: 154px; width: 100%;">
                                <thead class="my-table-head fw400">
                                    <th width="100">年份</th>
                                    <th class="text-left pl20">专业名称</th>
                                    <th width="100">选考要求</th>
                                    <th width="100">录取数</th>
                                    <th width="130">最高分</th>
                                    <th width="80">最低分</th>
                                    <th width="80">平均分</th>
                                    <th width="80">最低位次</th>
                                </thead>
                            </table>
                        </div>
                        <div class="tab">
                            <table class="my-table body">
                                <tbody class="my-table-body">
                                    <tr v-for="(it, index) in list2" :key="index">
                                        <td width="100" class="text-center"><span class="cntext">{{ it.Years }}</span>
                                        </td>
                                        <td class="pt20 pb20 pl20 " style="padding-right: 20px;">
                                            <a href="http://zy.ycymedu.com/majors/small?code=140101" target="_blank"
                                                class="flex-column text-color-title">
                                                <span class="cntext fw600 f14">{{ it.Major }}</span>
                                                <span class="cntext  f12 text-999 mt5">{{ it.Remark == null ? '-' :
                    it.Remark
                                                    }}</span>
                                            </a>
                                        </td>
                                        <td width="100" class="text-center"><span class="cntext">{{ it.SelectSubject
                                                }}</span></td>
                                        <td width="100" class="text-center"><span class="cntext">-</span></td>
                                        <td width="130" class="text-center"><span class="cntext">{{ it.HighScore
                                                }}</span>
                                        </td>
                                        <td width="80" class="text-center"><span class="cntext">{{ it.LowScore }}</span>
                                        </td>
                                        <td width="80" class="text-center"><span class="cntext">{{ it.AvgScore }}</span>
                                        </td>
                                        <td width="80" class="text-center"><span class="cntext">{{ it.LowScoreRank
                                                }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sm">
            <div class="smTitle">*说明</div>
            <div class="smContent">

                <p> 1、2012-2024年各院校录取数据，参考各省市出版的填报指南以及各本专科院校的官网历年录取数据；</p>
                <p>
                    2、我们的数据与各省考试院发布的数据一致，由于各省市加分政策，院校官网对征集志愿数据的显示等原因，会与院校官网存在不一致情况，建议以各省考试院发布的数据为准。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { GetPlanMajorScoreLinee } from "@/api/schoolDetails";
// import { getId } from "@/utils/auth.js";
export default {
    name: 'VoluntaryReportingIndex',
    components: {
    },
    props: {
        schoolId: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        code: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            loading: false,
            options: [{
                value: '1',
                label: '综合'
            }],
            value: '1',
            options1: [{
                value: '1',
                label: '理科'
            },
            {
                value: '2',
                label: '文科'
            }],
            list2: [],
        };
    },

    mounted() {
        this.getList2()
        console.log(this.$store.state);
        
    },

    methods: {
        async getList2() {
            const res = await GetPlanMajorScoreLinee(
                {
                    _uid: this.schoolId,
                    years: this.$store.state.user.startYear,
                    BatchName: '',
                    locationCode: this.$store.state.user.studentInfo.userExtend.provinceCode
                }
            )
            console.log(res);
            this.list2 = res.data.response
        },
    },

};
</script>

<style lang="less" scoped>
img {
    width: 100%;
    height: 100%;
}

.bb {
    position: relative;
    width: 100%;

    button {
        position: absolute;
        top: 153px;
        left: 50%;
        transform: translateX(-50%);
        width: 142px;
        height: 49px;
        background: #28C445;
        border-radius: 10px;
        border: none;
        font-size: 24px;
        font-weight: 500;
        line-height: 49px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
    }
}

.compBox {
    margin-top: 48px;
}

.tabels {
    margin-bottom: 20px;
}

.scoreline-bar {
    width: 100%;
    display: flex;
    margin-bottom: 20px;

    .major-scoreline-btn {
        font-size: 18px;
        margin-right: 10px;
        cursor: pointer;
    }

    .active {
        color: #187cff;
    }
}

.compBox {
    margin-top: 60px;

    .table {
        .tit {
            font-weight: bold;
            font-size: 28px;
            margin-bottom: 30px;
        }

        .selectBox {
            margin-bottom: 10px;
        }

        .dir-td {
            padding: 5px 12px;
            background: #fafafa;
            line-height: 20px;
            color: #1d2129;
            border: 1px solid #e8e8e8;
            border-bottom: none;
            font-size: 14px;
            padding-left: 20px;
            font-weight: bold;
        }

        .my-table {
            background-color: #fff;
            border-bottom: 1px dashed #e9e9e9;
            border-right: 1px solid #e8e8e8;
            border-top: 1px solid #e8e8e8;
            border-collapse: collapse;
            border-spacing: 0;

            .my-table-head th:first-child {
                border-left: 1px solid #e8e8e8;
            }

            .my-table-head th {
                border-bottom: 1px solid #e8e8e8;
                padding: 9px 0;
                font-size: 12px;
                color: #86909c;
            }

            .text-left {
                text-align: left !important;
            }

            .pl20 {
                padding-left: 20px !important;
            }
        }

        .tab {
            .my-table.body {
                border-top: none;
                width: 100%;

                tr.stripe {
                    background: #f7f7f7;

                }

                .text-color-title {
                    color: #1d2129;
                }

                .text-center {
                    text-align: center !important;
                }

                td {
                    font-size: 12px !important;
                    border-left: 1px solid #e8e8e8;
                    color: #333;
                    border-bottom: 1px solid #e8e8e8;
                }

                .pl20 {
                    padding-left: 20px !important;
                }

                .pb20 {
                    padding-bottom: 20px !important;
                }

                .pt20 {
                    padding-top: 20px !important;
                }

                .flex-column {
                    display: flex;
                    text-decoration: none;
                    flex-direction: column;

                    .fw600 {
                        font-weight: 600 !important;
                    }

                    .f14 {
                        font-size: 14px !important;
                    }

                    .text-999 {
                        color: #999 !important;
                    }

                    .f12 {
                        font-size: 12px !important;
                    }

                    .mt5 {
                        margin-top: 5px !important;
                    }

                    .cntext {
                        font-family: cntext !important;
                    }
                }
            }
        }
    }
}

.sm {
    margin: 23px 0;
    width: 100%;
    background: #fef0f0;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #ffeaea;
    padding: 16px;
    box-sizing: border-box;
    color: #f56c6c;

    .smTitle {
        margin-bottom: 12px;
        font-size: 20px;
    }

    .smContent {
        p {
            font-size: 14px;
            margin-bottom: 5px;
        }
    }
}
</style>